import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  PayrollExtraAPIService,
  PayrollExtraEntry,
} from 'app/api/payroll.extra.api.service';
import { AppState } from 'app/reducers';
import { parseErrorMessage } from 'app/utils/callstate';
import { sortBy } from 'lodash';
import { of, merge } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { PayrollExtraActions } from '../actions';

// const INITIAL_EXTRA: PayrollExtraEntry[] = [
//   {
//     companyId: 'advalo',
//     name: 'Cat prof',
//     key: 'pex#2',
//     applicable: true,
//     combobox: true,
//     choices:
//       'ouvrier|employé|agent maîtrise|cadre|cadre sup|TNS|Stagiaire|Alternants|Contrats pro',
//   },
//   {
//     companyId: 'advalo',
//     name: 'JEI',
//     key: 'pex#1',
//     applicable: true,
//     combobox: true,
//     choices: 'Oui|Non',
//   },
// ];

@Injectable()
export class PayrollExtraEffects {
  loadPayrollExtra$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayrollExtraActions.payrollExtraRequested),
      switchMap(({ query: { companyId, key, filter } }) =>
        this.payrollExtraApiService.PayrollExtra(companyId, key, filter).pipe(
          map((entries) => PayrollExtraActions.payrollExtraLoaded({ entries })),
          catchError((error) =>
            of(
              PayrollExtraActions.payrollExtraCancelled({
                errorMessage: parseErrorMessage(error),
              })
              // Load fake data
              // PayrollExtraActions.payrollExtraLoaded({ entries: INITIAL_EXTRA })
            )
          )
        )
      )
    )
  );

  createPayrollExtra$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayrollExtraActions.payrollExtraCreateRequested),
      mergeMap(({ input }) =>
        this.payrollExtraApiService.CreatePayrollExtraEntry(input).pipe(
          // tslint:disable-next-line: no-shadowed-variable
          map((input: PayrollExtraEntry) =>
            PayrollExtraActions.payrollExtraCreated({ input })
          ),
          catchError((error) =>
            of(
              PayrollExtraActions.payrollExtraCancelled({
                errorMessage: parseErrorMessage(error),
              })
            )
          )
        )
      )
    )
  );

  deleteOnePayrollExtra$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayrollExtraActions.payrollExtraRemoveOneRequested),
      mergeMap(({ input }) =>
        this.payrollExtraApiService.DeletePayrollExtraEntry(input).pipe(
          map(
            // tslint:disable-next-line: no-shadowed-variable
            (input) => PayrollExtraActions.payrollExtraRemoved({ input }),
            catchError((error) =>
              of(
                PayrollExtraActions.payrollExtraCancelled({
                  errorMessage: parseErrorMessage(error),
                })
              )
            )
          )
        )
      )
    )
  );

  updateOnePayrollExtra$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayrollExtraActions.payrollExtraUpdateOneRequested),
      mergeMap(({ input }) => {
        return this.payrollExtraApiService.UpdatePayrollExtraEntry(input).pipe(
          // tslint:disable-next-line: no-shadowed-variable
          map((entry) => PayrollExtraActions.payrollExtraUpdated({ input: entry })),
          catchError((error) =>
            of(
              PayrollExtraActions.payrollExtraCancelled({
                errorMessage: parseErrorMessage(error),
              })
            )
          )
        )
      }
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private payrollExtraApiService: PayrollExtraAPIService
  ) {}
}
